import React from 'react';
import styled, { css } from 'styled-components';
import { BodyRegular, BodyRegularSemiBold, Heading4 } from '@src/fonts/typography/Typography';
import { LayoutColors } from '@src/core/theme';
import { useAppSelector } from '@src/core/hooks';
import { passwordRecoveryEmailSelector } from '@src/features/auth';
import { useAppDispatch } from '../../../core/hooks';
import { confirmEmailResend, confirmEmailFix } from '../../../features/auth';
import { device } from '@src/common/breakpoints';
import useTranslate from '../../../i18n/useTranslate';
import { darken } from 'polished';

const ResendEmailModal = () => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslate();
  const passwordRecoveryEmail = useAppSelector(passwordRecoveryEmailSelector);

  const handleResendEmail = () => dispatch(confirmEmailResend());
  const handleFixEmail = () => dispatch(confirmEmailFix());

  return (
    <ModalMessageContainer>
      <ModalMessageTitle>{i18n('auth_recoverPassword')}</ModalMessageTitle>
      <ModalMessageInfo>
        {i18n('auth_resendEmailInfo')} <strong>{passwordRecoveryEmail}</strong>
      </ModalMessageInfo>
      <ModalMessageGroupButtons>
        <ModalMessagePrimaryButton onClick={handleResendEmail}>{i18n('auth_submit')}</ModalMessagePrimaryButton>
        <ModalMessageSecondaryButton onClick={handleFixEmail}>{i18n('auth_fixEmail')}</ModalMessageSecondaryButton>
      </ModalMessageGroupButtons>
    </ModalMessageContainer>
  );
};

const ModalMessageContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  background: ${LayoutColors.whiteDark};
  border-radius: 8px;
  max-width: 95%;
  ${device.smallTablet} {
    max-width: 577px;
  }
  padding: 24px;
  margin: 15% auto;
`;

const ModalMessageTitle = styled.h4`
  ${Heading4};
  color: ${LayoutColors.blackDark};
`;

const ModalMessageInfo = styled.p`
  ${BodyRegular};
`;

const ModalMessageGroupButtons = styled.div`
  ${BodyRegularSemiBold};
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  padding-top: 16px;
  width: 100%;
  ${device.smallTablet} {
    flex-direction: row;
  }
`;

const buttonStyled = css`
  padding: 10px 47px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid ${LayoutColors.successDark};
  width: 100%;
  ${device.smallTablet} {
    width: 100%;
  }
`;

const ModalMessagePrimaryButton = styled.button`
  ${buttonStyled};
  color: ${LayoutColors.whiteLight};
  background-color: ${LayoutColors.successDark};
  &:hover {
    background-color: ${darken(0.1, LayoutColors.successDark)};
  }
`;
const ModalMessageSecondaryButton = styled.button`
  ${buttonStyled};
  background-color: ${LayoutColors.whiteDark};
  color: ${LayoutColors.successDark};
`;

export default ResendEmailModal;
